import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RequestFormLoaderEffects } from './+state/effects';

// @dynamic
@NgModule({
  imports: [EffectsModule.forFeature([RequestFormLoaderEffects])]
})
export class AskResearchRequestFormLoaderModule {}
